import React, { useEffect, useRef, useState } from "react";
import './Join.css';
import joinLabelImage from './images/join/join-banner.png'; // Autumn recruitment banner
import heath from './images/headshots/heath.jpeg';

const Join = () => {
    const overlayRef = useRef(null);
    const [writeOn, setWriteOn] = useState(false);

    useEffect(() => {
        const el = overlayRef.current;
        if (!el) return;

        const io = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setWriteOn(true);      // start once
                    io.unobserve(el);      // don’t retrigger
                }
            },
            { threshold: 0.35 } // tweak: higher = later start
        );

        io.observe(el);
        return () => io.disconnect();
    }, []);

    const Handwrite = ({ text, baseDelay = 0 }) => {
        const words = text.split(" ");
        let globalIndex = 0;

        return (
            <span
                className="hw-line"
                style={{ "--base-delay": `${baseDelay}s` }}
                aria-label={text}
            >
                {words.map((word, wIdx) => {
                    const letters = Array.from(word);

                    // indices for this word
                    const startIndex = globalIndex;
                    globalIndex += letters.length;

                    // allocate an index for the space *without rendering it as a number*
                    const hasSpace = wIdx < words.length - 1;
                    const spaceIndex = hasSpace ? globalIndex : null;
                    if (hasSpace) globalIndex += 1;

                    return (
                        <React.Fragment key={wIdx}>
                            <span className="hw-word" aria-hidden="true">
                                {letters.map((ch, j) => (
                                    <span
                                        key={`${wIdx}-${j}`}
                                        className="hw-char"
                                        style={{ "--i": startIndex + j }}
                                        aria-hidden="true"
                                    >
                                        {ch}
                                    </span>
                                ))}
                            </span>

                            {hasSpace && (
                                <span
                                    className="hw-space"
                                    style={{ "--i": spaceIndex }}
                                    aria-hidden="true"
                                >
                                    {" "}
                                </span>
                            )}
                        </React.Fragment>
                    );
                })}
            </span>
        );
    };



    return (
        <div className="join-page">
            <div className="join-hero">
                <figure className="join-banner">
                    <img
                        src={joinLabelImage}
                        alt="BPAD Autumn Recruitment — Join the Team!"
                        loading="eager" decoding="sync" fetchpriority="high"
                    />
                </figure>
                {/* Marquee bar directly below — “part of the newspaper” */}
                <div className="join-marquee" aria-label="Join our community">
                    <span className="sr-only">BECOME A PART OF OUR COMMUNITY</span>

                    {/* duplicate groups for a seamless loop */}
                    <div className="join-marquee__track" aria-hidden="true">
                        <div className="join-marquee__group">
                            <span>BECOME A PART OF OUR COMMUNITY</span><span>•</span>
                            <span>BECOME A PART OF OUR COMMUNITY</span><span>•</span>
                            <span>BECOME A PART OF OUR COMMUNITY</span><span>•</span>
                            <span>BECOME A PART OF OUR COMMUNITY</span><span>•</span>
                        </div>
                        <div className="join-marquee__group" aria-hidden="true">
                            <span>BECOME A PART OF OUR COMMUNITY</span><span>•</span>
                            <span>BECOME A PART OF OUR COMMUNITY</span><span>•</span>
                            <span>BECOME A PART OF OUR COMMUNITY</span><span>•</span>
                            <span>BECOME A PART OF OUR COMMUNITY</span><span>•</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="join-content-section">
                <div className="join-button-section">
                    <div className="join-button-text">
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSdbcBxXC67-rP6dDS0uZfXQwcXK3aFhRfXPCjeLIbW62fjexw/viewform" target="_blank" rel="noopener noreferrer" className="recruitment-button">Fall 2026 Application</a>
                        <p>Click to access the Fall 2026 Application!</p>
                    </div>
                    <div className="join-button-image">
                        <div
                            ref={overlayRef}
                            className={`image-overlay-text ${writeOn ? "hw-start" : ""}`}
                        >
                            <h1>
                                <Handwrite text="Become a Champion." />
                            </h1>
                            <p>
                                <Handwrite text="Check out our Fall recruitment schedule below!"
                                    baseDelay={1.4}   /* ← HARD-CODED DELAY */
                                />
                            </p>
                        </div>
                    </div>
                </div>
                {/* General Events */}
                <div className="event-box-container general">
                    <a href="https://www.google.com/maps/search/?api=1&query=Hitchcock+Hall+Ohio+State+University" target="_blank" rel="noopener noreferrer" className="event-box">
                        <h1>INFO SESSION 1</h1>
                        <p>September 8th</p>
                        <p>Hitchcock 035</p>
                        <p>8:30pm-10pm</p>
                    </a>
                    <a href="https://www.google.com/maps/search/?api=1&query=Hitchcock+Hall+Ohio+State+University" target="_blank" rel="noopener noreferrer" className="event-box">
                        <h1>INFO SESSION 2</h1>
                        <p>September 9th</p>
                        <p>Hitchcock 131</p>
                        <p>8pm-10pm</p>
                    </a>
                    <a href="https://www.google.com/maps/search/?api=1&query=Hitchcock+Hall+Ohio+State+University" target="_blank" rel="noopener noreferrer" className="event-box">
                        <h1>MEMBER MINGLE</h1>
                        <p>September 10th</p>
                        <p>Hitchcock 035</p>
                        <p>8:30pm-10pm</p>
                    </a>
                    <a href="https://www.google.com/maps/search/?api=1&query=Blackburn+House+Ohio+State+University" target="_blank" rel="noopener noreferrer" className="event-box">
                        <h1>*PROFESSIONAL EVENT</h1>
                        <p>September 13th</p>
                        <p>Blackburn Victory Room</p>
                        <p>2pm-4pm</p>
                    </a>
                    <a href="https://www.google.com/maps/search/?api=1&query=Nosker+House+Ohio+State+University" target="_blank" rel="noopener noreferrer" className="event-box">
                        <h1>*SERVICE EVENT</h1>
                        <p>September 14th</p>
                        <p>Nosker Burgee Room</p>
                        <p>5pm-7pm</p>
                    </a>
                    <a href="https://www.google.com/maps/search/?api=1&query=Ohio+Union+Ohio+State+University" target="_blank" rel="noopener noreferrer" className="event-box">
                        <h1>*INTERVIEWS</h1>
                        <p>September 15th-18th</p>
                        <p>Ohio Union KBK</p>
                    </a>
                </div>
                <div className="asterisk">
                    <h2>*Invite Only Events</h2>
                </div>
                <div className="questions-comments">
                    <div className="separator"></div>
                    <h2>QUESTIONS, COMMENTS, CONCERNS?</h2>
                    <p>Please reach out to our Logistical Recruitment Director for assistance:</p>
                    <img src={heath} alt="Heath Younkin" className="director-image" />
                    <p className="director-name">Heath Younkin</p>
                    <p className="director-email">younkin.35</p>
                </div>

            </div>
        </div>
    );
};

export default Join;
